<script>
import TwModal from '../generic/modal/tw-modal.vue'
import modalCascadeMixin from '../../mixins/modalCascadeMixin.js'
import TwInput from '../generic/forms/tw-input.vue'
import TwEmail from '../generic/forms/tw-email.vue'

export default {
  name: 'TaxReceiptsRequestPublicModal',
  components: { TwEmail, TwInput, TwModal },
  mixins: [modalCascadeMixin],
  data() {
    return {
      Loading: false,
      ValidationErrorMessage: null,
      Email: null,
      SpecificDonor: false,
      Year: new Date().getFullYear()-1,
    }
  },
  methods: {
    async requestTaxReceipts() {
      try {
        this.ValidationErrorMessage = null
        this.Loading = true
        const { data } = await axios.post(`/api/v1/tax-receipts/request`,{
          year: this.Year,
          email: this.Email
        })
        this.Loading = false
        this.$notify(`${data.message}`)
        await this.close()
      } catch (e) {
        console.error(e)
        this.Loading = false
        if (e.response) this.ValidationErrorMessage = e.response.data
        throw e
      }
    }
  }
}
</script>

<template>
  <tw-modal ref="modal" :ok-disabled="Loading" :loading="Loading" title="Request Tax Receipts" @ok="requestTaxReceipts">
    <tw-email v-model="Email" label="The email that you used when you made the donation" />
    <tw-input v-model="Year" label="Select year" />
  </tw-modal>
</template>

<style scoped>

</style>
